module.exports = __webpack_public_path__ + "static/media/chart-pie.f2ea71ae.svg";